import { Store, select } from '@ngrx/store';
import { of } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { LoadingPolicyStatementResourceActionsAction, selectResourceActionsNeedLoading, selectStatementResources, selectLoadableResourceActions, selectStatementActions, selectStatementServices, LoadingPolicyStatementServicesAction, AddStatementAction, SelectEffectAction, SelectServiceAction, SelectResourceAction, SelectActionActions, ClearPolicyFormAction } from './index';
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/store";
var PolicyStatementFacadeService = /** @class */ (function () {
    function PolicyStatementFacadeService(store) {
        this.store = store;
        this.loadableServices$ = of();
        this.services$ = of();
        this.actions$ = of();
        this.resources$ = of();
        this.loadableResources$ = of();
    }
    PolicyStatementFacadeService.prototype.loadServices = function () {
        var _this = this;
        this.loadableServices$ = this.store.pipe(select(selectStatementServices));
        this.loadableServices$.pipe(filter(function (data) { return !data; })).subscribe(function () {
            return _this.store.dispatch(new LoadingPolicyStatementServicesAction());
        });
        this.services$ = this.loadableServices$.pipe(filter(function (loadable) { return loadable && loadable.data; }), map(function (loaded) { return loaded.data; }));
    };
    PolicyStatementFacadeService.prototype.loadResources = function (serviceId) {
        var _this = this;
        this.store.pipe(select(selectResourceActionsNeedLoading(serviceId)), filter(function (needLoading) { return needLoading; })).subscribe(function () {
            return _this.store.dispatch(new LoadingPolicyStatementResourceActionsAction({ serviceId: serviceId }));
        });
        this.resources$ = this.store.pipe(select(selectStatementResources(serviceId)));
        this.loadableResources$ = this.store.pipe(select(selectLoadableResourceActions(serviceId)));
    };
    PolicyStatementFacadeService.prototype.getActions = function (serviceId, resourceId) {
        return this.store.pipe(select(selectStatementActions(serviceId, resourceId)));
    };
    PolicyStatementFacadeService.prototype.setStatement = function (_a, statementIdx) {
        var effect = _a.effect, service = _a.service, resource = _a.resource, actions = _a.actions, statement_id = _a.statement_id;
        this.loadResources(service.id);
        this.store.dispatch(new AddStatementAction(statement_id));
        this.store.dispatch(new SelectEffectAction({ statementIdx: statementIdx, effect: effect }));
        this.store.dispatch(new SelectServiceAction({ statementIdx: statementIdx, service: service }));
        this.store.dispatch(new SelectResourceAction({ statementIdx: statementIdx, resource: resource }));
        this.store.dispatch(new SelectActionActions({ statementIdx: statementIdx, actions: actions }));
    };
    PolicyStatementFacadeService.prototype.clearPolicyForm = function () {
        this.store.dispatch(new ClearPolicyFormAction());
    };
    PolicyStatementFacadeService.prototype.addNewStatement = function () {
        this.store.dispatch(new AddStatementAction());
    };
    PolicyStatementFacadeService.ngInjectableDef = i0.defineInjectable({ factory: function PolicyStatementFacadeService_Factory() { return new PolicyStatementFacadeService(i0.inject(i1.Store)); }, token: PolicyStatementFacadeService, providedIn: "root" });
    return PolicyStatementFacadeService;
}());
export { PolicyStatementFacadeService };



// WEBPACK FOOTER //
// ./src/app/access-management/state/policy-statement.facade.ts.pre-build-optimizer.js